// extracted by mini-css-extract-plugin
export var recruitFood = "RecruitButton-module--recruitFood--5O272";
export var recruitUp = "RecruitButton-module--recruit-up--FfFhR";